<script setup lang="ts">
import { computed, provide } from "vue";

import RsFileTypeUnknown from "@/components/CasePanels/RecordView/DocumentViewer/FileTypeUnknown.vue";
import RsFileTypeArchive from "@/components/CasePanels/RecordView/DocumentViewer/FileTypeArchive.vue";
import RsFileTypeDocument from "@/components/CasePanels/RecordView/DocumentViewer/FileTypeDocument.vue";

import { useAnnotationStore } from "@/stores/annotation-store";

import { CASE_ROUTE_PARAMS_KEY } from "@/hooks/use-case-route-params";

import type { Metadata } from "@/models/Metadata";
import type { HighlightCustomArea } from "@/models/Viewer";
import type { DockviewPanelComponentEmits } from "@/hooks/use-case-panel";
import type { InjectedCaseRouteParams } from "@/hooks/use-case-route-params";

const props = defineProps<{
  isPopout: boolean;
  isVisible: boolean;
  file: Metadata;
  routeParams: InjectedCaseRouteParams;
  selectedArea: HighlightCustomArea | undefined;
  scale: { width: number; height: number };
}>();
defineEmits<DockviewPanelComponentEmits>();

const routeParams = computed(() => props.routeParams);

provide(CASE_ROUTE_PARAMS_KEY, routeParams);

function reloadAnnotations() {
  useAnnotationStore().load();
}
</script>
<template>
  <div class="tw-flex tw-size-full tw-items-center tw-justify-center tw-overflow-y-auto">
    <div v-if="['ac5', 'audio'].includes(file.fileType)" class="tw-grid tw-size-full tw-place-items-center">
      <div class="tw-max-w-sm tw-text-pretty">No document exists for this file</div>
    </div>
    <RsFileTypeUnknown
      v-else-if="file.fileType === 'unknown'"
      :file="file"
      :brand="routeParams.brand"
      :casename="routeParams.casename"
      :casefile="routeParams.casefile"
    />
    <RsFileTypeArchive
      v-else-if="file.fileType === 'archive'"
      :file="file"
      :brand="routeParams.brand"
      :casename="routeParams.casename"
      :casefile="routeParams.casefile"
    />
    <RsFileTypeDocument
      v-else
      :file="file"
      :viewer-scale="scale"
      :is-visible="isVisible"
      :selected-area="selectedArea"
      @reload-annotations="reloadAnnotations"
      @panel-popout-action="(arg) => $emit('panelPopoutAction', arg)"
    />
  </div>
</template>
